import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "radar_access_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));
let unauthorizedHandler = () => {};
export const onUnauthorized = (fn) => { unauthorizedHandler = fn; };
export const logout = () => unauthorizedHandler();
export const withToken = (url) => `${url}${url.includes("?") ? "&" : "?"}token=${encodeURIComponent(getToken() || "")}`;
export const formatErr = (d) => {
  if (d == null) return "Une erreur est survenue.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return d.msg || String(d);
};
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
api.interceptors.response.use((r) => r, (err) => {
  const url = err.config?.url || "";
  if (err.response?.status === 401 && !url.includes("/auth/login") && !url.includes("/auth/change-code")) unauthorizedHandler();
  return Promise.reject(err);
});

export const toQS = (params = {}) => {
  const sp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "" || v === false) return;
    if (Array.isArray(v)) v.forEach((x) => sp.append(k, x));
    else sp.append(k, v === true ? "1" : v);
  });
  return sp.toString();
};

export const get = (url, params) => api.get(params ? `${url}?${toQS(params)}` : url).then((r) => r.data);
export const post = (url, body) => api.post(url, body).then((r) => r.data);
export const patch = (url, body) => api.patch(url, body).then((r) => r.data);
export const del = (url) => api.delete(url).then((r) => r.data);

export const useConfig = () => useQuery({ queryKey: ["config"], queryFn: () => get("/config"), staleTime: 300000 });

const DAYS = ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."];
export const fmtDate = (d, withDay = true) => {
  if (!d) return "—";
  const [y, m, day] = d.split("-");
  const wd = DAYS[new Date(`${d}T12:00:00`).getDay()];
  return `${withDay ? wd + " " : ""}${day}/${m}/${y.slice(2)}`;
};
export const fmtDT = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" });
};
export const fmtPrice = (e) => {
  if (e.access === "gratuit") return "Gratuit";
  if (e.price_min == null) return e.access === "payant" ? "Payant" : "INCONNU";
  if (e.price_min === e.price_max) return `${e.price_min} €`;
  return `${e.price_min}–${e.price_max} €`;
};
export const isoDay = (d) => {
  const z = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  return z.toISOString().slice(0, 10);
};
export const addDays = (d, n) => {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
};
